import {startBeforeOREqualToEnd, UTC} from "../utils/dateutils";

const storageKeys = {
  AUTH_TOKEN: ":iroh-auth-token",
  INCIDENT_MANAGER_SETTINGS: "im-settings",
  LAST_CUSTOM_DATERANGE: "im-last-custom-daterange",
  PROFILE_SETTINGS: "im-profile-settings",
  SESSION_USER: window.__SHELL__ ? ":iroh-session-info" : "im-session-user",
  THEME: "persist-magna-react-theme"
};

/**
 * Get value from Local Storage
 *
 * @param {string} key Local Storage Key
 * @returns {string} Local Storage Value
 */
export const getFromLocalStorage = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (err) {
    return undefined;
  }
};

/**
 * Set a local Storage Key/Value pair.
 *
 * @param {String} key Key to set.
 * @param {String} value Value to set.
 */
export const setLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (err) {
    // prevent storage errors from percolating up
  }
};

export const getAuthToken = () => {
  const token = getFromLocalStorage(storageKeys.AUTH_TOKEN);

  if (token === null || token === "null") {
    return undefined;
  }
  return token;
};

export const setAuthToken = (token) => {
  setLocalStorage(storageKeys.AUTH_TOKEN, token);
};

export const setSessionUser = (user) => {
  if (!window.__SHELL__) {
    try {
      if (user) {
        user.authToken = getAuthToken();
      }
      const serializedUser = JSON.stringify(user);
      setLocalStorage(storageKeys.SESSION_USER, serializedUser);
    } catch (err) {
      // prevent stringify error from percolating up
    }
  }
};

export const getSessionUser = () => {
  try {
    const serializedUser = getFromLocalStorage(storageKeys.SESSION_USER);
    if (serializedUser === null || serializedUser === "null") {
      return undefined;
    }
    const user = JSON.parse(serializedUser);
    return user;
  } catch (err) {
    return undefined;
  }
};

export const setRecentlyViewedIncidentId = (id) => {
  try {
    setLocalStorage(storageKeys.RECENTLY_VIEWED_INCIDENT, JSON.stringify(id));
  } catch (err) {
    // prevent stringify error from percolating up
  }
};

export const getIncidentManagerSettings = () => {
  try {
    const serializedSettings = getFromLocalStorage(
      storageKeys.INCIDENT_MANAGER_SETTINGS
    );
    if (serializedSettings === null || serializedSettings === "null") {
      return null;
    }
    return JSON.parse(serializedSettings);
  } catch (err) {
    return null;
  }
};

export const setIncidentManagerSettings = (settings) => {
  try {
    setLocalStorage(
      storageKeys.INCIDENT_MANAGER_SETTINGS,
      JSON.stringify(settings)
    );
  } catch (err) {
    // prevent stringify error from percolating up
  }
};

export const getProfileSettings = () => {
  try {
    const serializedSettings = getFromLocalStorage(
      storageKeys.PROFILE_SETTINGS
    );
    if (serializedSettings === null) {
      return {timezone: UTC, dateFormat: "YYYY-MM-DDTHH:mm:ss.000Z"};
    }
    return JSON.parse(serializedSettings);
  } catch (err) {
    return {timezone: UTC, dateFormat: "YYYY-MM-DDTHH:mm:ss.000Z"};
  }
};

export const getLastCustomRangeFilter = () => {
  try {
    const serializedValue = getFromLocalStorage(
      storageKeys.LAST_CUSTOM_DATERANGE
    );
    if (serializedValue === null) {
      return undefined;
    }
    const value = JSON.parse(serializedValue);
    if (
      value &&
      startBeforeOREqualToEnd(value.startDate, value.endDate, "day")
    ) {
      return value;
    }
    return undefined;
  } catch (err) {
    return undefined;
  }
};

export const setLastCustomRangeFilter = (value) => {
  try {
    const serializedValue = JSON.stringify(value);
    setLocalStorage(storageKeys.LAST_CUSTOM_DATERANGE, serializedValue);
  } catch (err) {
    // prevent stringify error from percolating up
  }
};
